<mat-toolbar class="gap-1 items-center">
  <button
    class="btn-normal"
    id="tools"
    [cdkMenuTriggerFor]="menu"
    matTooltip="工具"
  >
    <mat-icon fontIcon="build_circle" slot="start"></mat-icon>
  </button>
  @if (insertVisible()) {
    <button
      class="btn-insert"
      (click)="doInsert($event)"
      matTooltip="新增"
      [disabled]="insertDisabled"
      [class.btn-disabled]="insertDisabled"
      [class.btn-insert]="!insertDisabled"
    >
      <mat-icon fontIcon="add" slot="start" name="add-outline"></mat-icon>
    </button>
  }
  @if (editVisible()) {
    <button
      (click)="doEdit($event)"
      matTooltip="修改"
      [disabled]="editDisabled"
      [class.btn-disabled]="editDisabled"
      [class.btn-edit]="!editDisabled"
    >
      <mat-icon fontIcon="edit" slot="start" name="create-outline"></mat-icon>
    </button>
  }
  @if (postVisible()) {
    <button
      (click)="doPost($event)"
      matTooltip="確定"
      [disabled]="postDisabled"
      [class.btn-disabled]="postDisabled"
      [class.btn-post]="!postDisabled"
    >
      <mat-icon
        fontIcon="done"
        slot="start"
        name="checkmark-outline"
      ></mat-icon>
    </button>
  }
  @if (cancelVisible()) {
    <button
      (click)="doCancel($event)"
      matTooltip="取消"
      [disabled]="cancelDisabled"
      [class.btn-disabled]="cancelDisabled"
      [class.btn-cancel]="!cancelDisabled"
    >
      <mat-icon fontIcon="cancel" slot="start" name="close-outline"></mat-icon>
    </button>
  }
  @if (deleteVisible()) {
    <button
      (click)="doDelete($event)"
      matTooltip="刪除"
      [disabled]="deleteDisabled"
      [class.btn-disabled]="deleteDisabled"
      [class.btn-delete]="!deleteDisabled"
    >
      <mat-icon fontIcon="delete" slot="start" name="trash-outline"></mat-icon>
    </button>
  }
  @if (editAndSaveVisible()) {
    <button
      (click)="doEditAndSave(undefined)"
      [disabled]="editAndSaveDisabled()"
      [class.btn-disabled]="editAndSaveDisabled()"
      [class.btn-editAndSave]="!editAndSaveDisabled()"
      matTooltip="存檔"
    >
      <mat-icon fontIcon="save" slot="start" name="save-outline"></mat-icon>
    </button>
  }
  @if (user1Visible) {
    <button
      id="u1"
      (click)="user1($event)"
      [disabled]="user1Disabled()"
      [class.btn-disabled]="user1Disabled()"
      [class.btn-normal]="!user1Disabled()"
    >
      {{ userCaption1 }}
    </button>
  }
  @if (user2Visible) {
    <button
      class="btn-normal"
      id="u2"
      (click)="user2($event)"
      [disabled]="user2Disabled()"
    >
      {{ userCaption2 }}
    </button>
  }
  @if (user3Visible) {
    <button
      class="btn-normal"
      id="u3"
      (click)="user3($event)"
      [disabled]="user3Disabled()"
    >
      {{ userCaption3 }}
    </button>
  }
  @if (user4Visible) {
    <button
      class="btn-normal"
      id="u4"
      (click)="user4($event)"
      [disabled]="user4Disabled()"
    >
      {{ userCaption4 }}
    </button>
  }
  @if (navigateVisible()) {
    @if (firstVisible()) {
      <button
        (click)="onFirstRow()"
        matTooltip="第一筆"
        [disabled]="firstDisabled"
        [class.btn-disabled]="firstDisabled"
        [class.btn-normal]="!firstDisabled"
      >
        <mat-icon>first_page</mat-icon>
      </button>
    }
    @if (previousVisible) {
      <button
        (click)="onPreviousRow()"
        matTooltip="上一筆"
        [disabled]="previousDisabled"
        [class.btn-disabled]="previousDisabled"
        [class.btn-normal]="!previousDisabled"
      >
        <mat-icon>navigate_before</mat-icon>
      </button>
    }
    @if (nextVisible) {
      <button
        (click)="onNextRow()"
        matTooltip="下一筆"
        [disabled]="nextDisabled"
        [class.btn-disabled]="nextDisabled"
        [class.btn-normal]="!nextDisabled"
      >
        <mat-icon>navigate_next</mat-icon>
      </button>
    }
    @if (lastVisible) {
      <button
        (click)="onLastRow()"
        matTooltip="最後一筆"
        [disabled]="lastDisabled"
        [class.btn-disabled]="lastDisabled"
        [class.btn-normal]="!lastDisabled"
      >
        <mat-icon>last_page</mat-icon>
      </button>
    }
  }
</mat-toolbar>

<ng-template #menu class="example-menu-bar-item">
  <div class="example-menu" cdkMenu>
    <button class="example-menu-bar-item" cdkMenuItem (click)="user1($event)">
      user1
    </button>
    <button class="example-menu-bar-item" cdkMenuItem (click)="user2($event)">
      user2
    </button>
  </div>
</ng-template>
